import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../AuthContext'

const Footer = () => {
	const {user}=useAuth()
  return (
    <div>
        <section className="footer pt-120">
	<div className="container">
		<div className="row">
			<div className="col-lg-4 mr-auto col-sm-6 col-md-6">
				<div className="widget footer-widget mb-5 mb-lg-0">
					<h5 className="widget-title">About Us</h5>
					<p className="mt-3">Monarch Institute offers comprehensive coaching services for medical entrance examinations, NEET.</p>
					<p><i className="bi bi-phone mr-2"></i>Telephone: (+91) 9136431685</p>
					<p><i className="bi bi-envelop mr-2"></i>Email: info@monarchinstitute.in</p>
					<ul className="list-inline footer-socials">
						<li className="list-inline-item"><a target='_blank' rel='noreferrer' href="https://www.facebook.com/people/Monarch-Institute/61567960886635/"><i className="fab fa-facebook-f"></i></a></li>
						<li className="list-inline-item"> <a target='_blank' rel='noreferrer' href="https://www.youtube.com/@monarchinstitute-neet"><i className="fab fa-youtube"></i></a></li>
						<li className="list-inline-item"><a target='_blank' rel='noreferrer' href="https://www.linkedin.com/in/monarch-institute-61b591349/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BrYWxCqO9RbmDOJaAZ20TwQ%3D%3D"><i className="fab fa-linkedin"></i></a></li>
					</ul>
				</div>
			</div>
			
			<div className="col-lg-2 col-sm-6 col-md-6">
				<div className="footer-widget mb-5 mb-lg-0">
					<h5 className="widget-title">Information</h5>
					<ul className="list-unstyled footer-links">
						<li><Link to='/about-us'>About us</Link></li>
						<li><Link to='/contact-us'>Contact us</Link></li>
						<li><Link to='/terms-and-condition'>Terms & Condition</Link></li>
						<li><Link to='/privacy-policy'>Privacy policy</Link></li>
					</ul>
				</div>
			</div>
			<div className="col-lg-2 col-sm-6 col-md-6">
				<div className="footer-widget mb-5 mb-lg-0">
					<h5 className="widget-title">Admimission</h5>
					<ul className="list-unstyled footer-links">
						<li><Link to='/register'>Admimission process (Online)</Link></li>
					</ul>
				</div>
			</div>
			<div className="col-lg-3 col-sm-6 col-md-6">
				<div className="footer-widget footer-contact mb-5 mb-lg-0">
					<h5 className="widget-title">Student Area</h5>
					
					<ul className="list-unstyled">
					<li><Link to={`/student/${user?.email}`} className='text-white'>Answers & Solutions</Link></li>
					<li><Link to={`/student/${user?.email}`} className='text-white'>Test Schedule</Link></li>
					</ul>
				</div>
			</div>
		</div>
	</div>

	<div className="footer-btm">
		<div className="container">
			<div className="row justify-content-center align-items-center">
				<div className="col-lg-6">
					{/* <div className="footer-logo">
						<img src="assets/images/logo-white.png" alt="Edutim" className="img-fluid"/>
					</div> */}
					<div className="copyright text-lg-center">
						<p>@ Copyright reserved to Monarch  </p>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="copyright text-lg-center">
						<p>Design by <a target='_blank' href="https://technobizzar.com/">Technobizzar</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
    </div>
  )
}

export default Footer
